'use client'

// Phone — the payphone (phone.glb) by the second takeaway. Placement is
// baked into the export's node transform (Payphone_Baked ≈ [-26, 0, 50], next
// to the `phone` POI), so it drops in at identity like RadioTower/Buildings.
// Materials rebuilt as MeshStandardNodeMaterial so it lights, shadows, and
// runs through RendererDither with the rest of the world.

import { useEffect } from 'react'
import * as THREE from 'three/webgpu'
import { useModel } from '../hooks/useModel'

const MODEL = '/models/phone.glb'

export function Phone() {
  const { scene } = useModel(MODEL)

  useEffect(() => {
    const converted = new Map()
    scene.traverse((o) => {
      if (!o.isMesh) return
      o.castShadow = true
      o.receiveShadow = true
      const src = o.material
      if (!src || Array.isArray(src) || src.isNodeMaterial) return
      let nm = converted.get(src)
      if (!nm) {
        nm = new THREE.MeshStandardNodeMaterial()
        if (src.map) nm.map = src.map
        nm.color = src.color?.clone() ?? new THREE.Color('white')
        nm.roughness = src.roughness ?? 1
        nm.metalness = src.metalness ?? 0
        nm.side = src.side
        nm.vertexColors = src.vertexColors
        converted.set(src, nm)
      }
      o.material = nm
    })
  }, [scene])

  // Placement baked into the export — render at identity.
  return <primitive object={scene} />
}

export default Phone
